import { useUsers } from "../../logic/hooks/useUsers.js";
import { UsersListPanel } from "./UsersListPanel.jsx";

export function UsersPage() {
  const vm = useUsers();

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <UsersListPanel
        users={vm.items}
        loading={vm.loading}
        search={vm.search}
        onSearchChange={vm.setSearch}
        selectedId={vm.selectedId}
        onSelect={vm.setSelectedId}
        selectedUser={vm.selectedUser}
        permissions={vm.permissions}
        permsLoading={vm.permsLoading}
        onRemovePermission={vm.removePermission}
        onDisableUser={vm.disableUser}
        onEnableUser={vm.enableUser}
        statusSaving={vm.statusSaving}
        addPermOpen={vm.addPermOpen}
        onToggleAddPerm={vm.setAddPermOpen}
        addablePermissions={vm.addablePermissions}
        onAddPermission={vm.addPermission}
      />
    </div>
  );
}
